import {
  SettingsFormControl,
  SettingsGroup,
  TextInputField
} from '@sequencehq/core-components'

import { MerchantBankAccountDetails } from '../bankDetails.types'

import { BASE_INPUT_FIELD_STYLES } from 'SettingsV2/settings.constants'
import { useForm } from '@sequencehq/utils'
import { required } from '@sequencehq/utils/validation'

export const useIBANAccountForm = ({
  bankDetails,
  showValidationErrors
}: {
  bankDetails?: MerchantBankAccountDetails['value']
  showValidationErrors: boolean
}) => {
  return useForm({
    value: {
      iban: bankDetails?.iban ?? ''
    },
    showValidationErrors,
    fieldConfiguration: [
      {
        property: 'iban',
        validation: [required]
      }
    ]
  })
}

export const IbanAccountForm = ({
  fields
}: {
  fields: ReturnType<typeof useIBANAccountForm>['fields']
}) => (
  <SettingsGroup title="Account details">
    <SettingsFormControl label="IBAN" htmlFor="iban">
      <TextInputField
        {...BASE_INPUT_FIELD_STYLES}
        placeholder="12345678"
        id="iban"
        value={fields.iban.value}
        validationErrors={fields.iban.validationErrors}
        onChange={e => {
          fields.iban.onChange(e.target.value)
        }}
      />
    </SettingsFormControl>
  </SettingsGroup>
)
